var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#478AFF",
    fillRule: "evenodd",
    d: "M13.499 7.354a6.153 6.153 0 1 0 6.154 6.152 6.158 6.158 0 0 0-6.154-6.152Zm12.288.558-.118-.257-.185.215a4.22 4.22 0 0 1-1.692 1.164l-.184.066.072.185a11.05 11.05 0 0 1 .846 4.236c0 6.092-4.941 11.038-11.036 11.038S2.456 19.613 2.456 13.519c0-6.095 4.942-11.036 11.036-11.036 1.64 0 3.254.364 4.735 1.067l.171.082.073-.185a4.248 4.248 0 0 1 1.248-1.63l.217-.185-.248-.13A13.365 13.365 0 0 0 13.53 0h-.035C6.045 0 0 6.044 0 13.499c0 7.455 6.049 13.499 13.499 13.499 7.457 0 13.499-6.044 13.499-13.5 0-1.932-.413-3.846-1.217-5.602l.006.016Zm-.652-2.817a2.8 2.8 0 1 0-5.603 0 2.801 2.801 0 1 0 5.603 0Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27v27H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/Ionic.97fb8460d02fb0f9fc58b38831d0f39f.svg";
export { ForwardRef as ReactComponent };